var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'etiquette d-flex justify-content-center align-items-center mini-title m-auto ' +
    _vm.kind},[_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }